import { call, put, takeLatest } from 'redux-saga/effects'
import { PayloadAction } from '@reduxjs/toolkit'

import medecinModel, { Medecin } from '@/core/models/medecin.model'
import staffModel, { CreateStaffDto, Staff } from '@/core/models/staff.model'
import { SearchRequestOptions } from '@/core/types/request'

import {
  addStaffSuccess as addStaffSuccessAction,
  addStaffFailure as addStaffFailureAction
} from '@/redux/reducers/staff.reducer'
import {
  getMedecins as getMedecinsAction,
  getMedecinsSuccess as getMedecinsSuccessAction,
  getMedecinsFailure as getMedecinsFailureAction,
  addMedecin as addMedecinAction,
  addMedecinSuccess as addMedecinSuccessAction,
  addMedecinFailure as addMedecinFailureAction,
} from '@/redux/reducers/medecin.reducer'

import { handleError } from '@/utils/errors'

function* getMedecins(action: PayloadAction<{ query: Record<string, any>; options?: SearchRequestOptions }>) {
  try {
    const { query, options } = action.payload
    const [medecins, totalCount]: [Medecin[], number] = yield call(medecinModel.getMedecins, query, options)
    yield put(getMedecinsSuccessAction({ items: medecins, totalCount }))
  } catch (exception) {
    console.warn(exception)
    yield put(getMedecinsFailureAction(handleError(exception)))
  }
}

function* addMedecin(action: PayloadAction<CreateStaffDto>) {
  try {
    const medecin: Staff = yield call(staffModel.addStaff, action.payload)
    yield put(addMedecinSuccessAction(medecin))
    yield put(addStaffSuccessAction(medecin))

  } catch (exception) {
    console.warn(exception)
    yield put(addStaffFailureAction(handleError(exception)))
    yield put(addMedecinFailureAction(handleError(exception)))
  }
}

const sagas = [takeLatest(getMedecinsAction.type, getMedecins), takeLatest(addMedecinAction.type, addMedecin)]

export default sagas
